
import React from "react";
export interface CardContent {
  title: string;
  intro?: string;
  content: string | string[];
  step: string;
  author?: string;
  role?: string;
}
interface CaseStudyCardProps {
  card: CardContent;
  studyId: string;
  index: number;
}
const CaseStudyCard = ({
  card,
  studyId,
  index
}: CaseStudyCardProps) => {
  // Map step numbers to corresponding titles
  const getTitleFromStep = (step: string) => {
    switch (step) {
      case "01":
        return "Challenge";
      case "02":
        return "Approach";
      case "03":
        return "Results";
      case "04":
        return "Testimonial";
      default:
        return card.title;
    }
  };
  return <div key={`${studyId}-card-${index}`} className="bg-white rounded-2xl shadow-card h-full border border-grayLight/30">
      <div className="p-5 h-full flex flex-col">
        <span className="text-sm font-medium text-cyanPrimary mb-2">
          {card.step}
        </span>
        <h3 className="text-xl font-bold mb-4 pb-2 border-b-2 border-cyanPrimary/20 inline-block">
          {getTitleFromStep(card.step)}
        </h3>
        {Array.isArray(card.content) ? <div className="text-grayText">
            {card.intro && <p className="mb-3 text-left">{card.intro}</p>}
            <ul className="space-y-2">
              {card.content.map((item, j) => <li key={j} className="flex items-start">
                  <div className="min-w-2 h-2 w-2 bg-cyanPrimary rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <span className="text-left">{item}</span>
                </li>)}
            </ul>
          </div> : card.step === "04" ? <div className="relative">
            <div className="text-5xl absolute -left-2 -top-4 text-cyanPrimary opacity-20 font-serif">
              "
            </div>
            <p className="text-grayText leading-relaxed italic relative pl-3 text-left">
              {card.content}
            </p>
            {card.author && <p className="text-right font-semibold text-darkText mt-3">
                {card.author}<br />{card.role}
              </p>}
          </div> : <p className="text-grayText leading-relaxed text-left">
            {card.content}
          </p>}
      </div>
    </div>;
};
export default CaseStudyCard;
